import axios from 'axios'

export default function ({state, commit, dispatch}) {
    return new Promise(resolve => {
        // console.info("test");
        commit('resolves', resolve);
       /* if(!state.loading&&state.settings.length){
            commit('resolves');
            return;
        }*/
        if(state.loading){
            return;
        }
        commit('loading', true);
        axios({
            method: 'get',
            url: '/tourclient/Settings/PaymentIntegrationSettingsList'
        }).then(
            ({data}) => {
                if (data) {
                    let settings = data.Settings.map(set => {
                        if (!set.LegalEntityId) {
                            set.LegalEntityId = 0
                        };
                        if (set.LegalEntityName === '<не указано>') {
                            set.LegalEntityName = 'Для всех'
                        };
                        set.PaymentRoutes.forEach(i=>{
                          if (!i.LegalEntityId) {
                            i.LegalEntityId = 0
                          }
                        });
                        return set;
                    });
                    commit('settings', settings);
                }
                commit('resolves');
                commit('loading', false);
            },
            err => {
                commit('resolves');
                commit('loading', false);
                dispatch('error', err, {root: true});
            }
        );
    })
}
